const initialState = {
  cbpAuthPdfPrint: false,
};

export default initialState;
